// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".over-flow[data-v-664c2015]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.W100[data-v-664c2015]{width:100%}p[data-v-664c2015]{margin:0}", ""]);
// Exports
module.exports = exports;
